import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemListWithSourceIdentifierAggregation',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: ({ type, source = 'PollResponse' }) => {
        return o.pipeline(
            o.sources.vocItems({
                appId: 'expandAppIds("*")',
                type,
            }),
            o.filter(`sourceCategory == "PendoUI" && source == "${source}"`),
            o.select({ vocItemId: 'id', pollResponseId: 'sourceIdentifier' }),
        );
    },
};
